<template>
  <div class="gcc-filter-container">
    <ul class="course-cohorts" v-for="course in groupCourses" :key="course.GroupCourseMasterId">
      <li v-for="cohort in getCourseCohorts(course.GroupCourseMasterId)" :key="cohort.CohortId">{{ cohort.CohortName }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TestPage',

  // components: {
  //   'gcc-course': GccCourse,
  //   'gcc-cohort': GccCohort
  // },

  data () {
    return {
      selectedCourses: []
    }
  },

  computed: {
    groupCourses () {
      return this.$store.getters.groupCourses
    }
  },

  methods: {
    getCourseCohorts (courseId) {
      return this.$store.getters.cohortsByCourseId(courseId)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/TestPage.vue